import {
  GET_GROUP_DETAIL,
  CREATE_GROUP,
  UPDATE_GROUP,
  DELETE_GROUP,
  TRANSFER_STUDENTS_TO_ANOTHER
} from '../action-types'
import {
  SET_GROUPS_LIST,
  SET_GROUP_DETAIL,
  SET_GROUP_SENDING,
  SET_GROUP_LOADING,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_INFORMATION_SNACKBAR_STATE,
  ADD_TO_GROUP_SUCCESS,
  CREATE_NEW_GROUP_SUCCESS,
  STUDENTS_LIST_LOADING,
  STUDENTS_LIST_NOT_LOADING,
  SWITCH_TABLE_MODE,
  REMOVE_GROUP,
  REMOVE_GROUP_STORAGE,
  SET_SELECTED_GROUP,
  SET_GROUP_CREATE_LOADING,
  SET_GROUP_UPDATE_LOADING,
  UNSET_DEFAULT_MYGROUP_ID,
  UNSET_SELECTED_GROUP,
  SET_STUDENT_COUNT_IN_GROUP
} from '../mutation-types'
import server from '../server'
import { informationTexts } from './information'
import { SELECTED_GROUP_IS_EMPTY } from '../getter-types'

const state = {
  groups: [],
  group: {},
  selectedGroup: {},
  studentIdsList: [],
  sending: false,
  loading: false,
  createLoading: false,
  updateLoading: false,
  unchecked: false,
  isNewGroup: false,
  tableMode: 'MYSTUDENTS'
}

const getters = {
  [SELECTED_GROUP_IS_EMPTY] (state) {
    return Object.keys(state.selectedGroup).length === 0
  }
}

const mutations = {
  [SET_GROUPS_LIST] (state, groups) {
    state.groups = groups.filter(group => group.name !== 'untitled_group').reverse()
    if (state.selectedGroup && state.selectedGroup.id) {
      state.selectedGroup = groups.find(x => x.id === state.selectedGroup.id)
    }
  },
  [SET_STUDENT_COUNT_IN_GROUP] (state, {groupId, studentCount}) {
    const group = state.groups.find(x => x.id === groupId)
    if (!group) {
      return
    }
    if (state.selectedGroup && state.selectedGroup.id === groupId) {
      state.selectedGroup.results = studentCount
    }
  },
  [SET_GROUP_DETAIL] (state, group) {
    state.group = group
  },
  [SET_GROUP_SENDING] (state, value) {
    state.sending = value
  },
  [SET_GROUP_LOADING] (state, value) {
    state.loading = value
  },
  [SET_GROUP_CREATE_LOADING] (state, value) {
    state.createLoading = value
  },
  [SET_GROUP_UPDATE_LOADING] (state, value) {
    state.updateLoading = value
  },
  [SET_SELECTED_GROUP] (state, value) {
    state.selectedGroup = value
  },
  [ADD_TO_GROUP_SUCCESS] (state, value) {
    state.unchecked = value
  },
  [CREATE_NEW_GROUP_SUCCESS] (state, value) {
    state.isNewGroup = value
  },
  [SWITCH_TABLE_MODE] (state, value) {
    state.tableMode = value
    localStorage.setItem('layout-mode', value)
  },
  [REMOVE_GROUP] (state, id) {
    state.groups = state.groups.filter(item => item.id !== id)
  },
  [REMOVE_GROUP_STORAGE] (state) {
    localStorage.removeItem('layout-mode')
    localStorage.removeItem('default-group')
    state.tableMode = 'MYSTUDENTS'
  },
  [UNSET_SELECTED_GROUP] (state, id) {
    state.selectedGroup = {}
  }
}

const actions = {
  [GET_GROUP_DETAIL] ({ commit }, groupId) {
    const actionData = { action: GET_GROUP_DETAIL }
    const url = `/core/mygroup/${groupId}`
    commit(STUDENTS_LIST_LOADING)
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_GROUP_DETAIL, result.data.students)
        commit(STUDENTS_LIST_NOT_LOADING)
      })
      .catch(error => {
        commit(STUDENTS_LIST_LOADING)
        console.error(error)
      })
  },
  async [CREATE_GROUP] ({ commit }, request) {
    const actionData = { action: CREATE_GROUP }
    const url = `/core/mygroup`
    commit(SET_GROUP_CREATE_LOADING, true)
    await server.postReplayable(url, request, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.GROUP_CREATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_GROUP_CREATE_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_GROUP_CREATE_LOADING, false)
      })
  },
  async [UPDATE_GROUP] ({ commit, state }, data) {
    const actionData = { action: UPDATE_GROUP }
    const url = `/core/mygroup/${data.groupId}`
    commit(SET_GROUP_UPDATE_LOADING, true)
    await server.putReplayable(url, data.request, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.GROUP_UPDATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_GROUP_UPDATE_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_GROUP_UPDATE_LOADING, false)
      })
  },
  async [DELETE_GROUP] ({ commit }, {groupId, deleteFlag}) {
    const actionData = { action: DELETE_GROUP }
    const url = `/core/mygroup/${groupId}?physical=${deleteFlag}`
    commit(SET_GROUP_SENDING, true)
    await server.deleteReplayable(url, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.GROUP_DELETED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_GROUP_SENDING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_GROUP_SENDING, false)
      })
  },
  async [TRANSFER_STUDENTS_TO_ANOTHER] ({ commit, state }, data) {
    const actionData = { action: TRANSFER_STUDENTS_TO_ANOTHER }
    const url = `/core/mygroup/${data.myGroupId}/student/all/transfer/${data.groupId}?removeOriginalGroup=true`
    commit(SET_GROUP_SENDING, true)
    await server.putReplayable(url, {}, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.GROUP_STUDENTS_ADDED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_GROUP_SENDING, false)
        commit(ADD_TO_GROUP_SUCCESS, true)
        commit(SWITCH_TABLE_MODE, 'MYSTUDENTS')
        commit(UNSET_DEFAULT_MYGROUP_ID)
        commit(SET_SELECTED_GROUP, {
          id: result.data.id,
          name: result.data.name,
          results: result.data.students ? result.data.students.length : 0
        })
      })
      .catch(error => {
        console.error(error)
        commit(SET_GROUP_SENDING, false)
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.GROUP_STUDENTS_EXISTED)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/groups.js